<template>
  <div id="contactUs" v-bind:style="{height: height, 'margin-top': marginTop}">
    <div class="top-bg-wrapper" v-if="showTopBG" :style="{top: topBGTopOffest, 'background-color': topBGColor}">
      <img :src="topBGImageURL" alt="">
    </div>
    <div class="bg-wrapper" :style="{'background-image': bgImageURL, 'background-color': bgColor}"></div>
    <span class="en-email">sales@everonet.com</span>
    <h1 class="en-tel">{{ t('telephone') }}</h1>
    <small class="en-address">{{ t('companyAddress') }}</small>
    <form class="en-form">
      <div class="form-group">
        <input type="text" id="fullName" v-model.trim="fullName" placeholder="Full name">
        <div class="tooltip right" v-show="needCheck && $vuerify.$errors['fullName']">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner">{{$vuerify.$errors['fullName']}}</div>
        </div>
      </div>
      <div class="form-group">
        <input type="text" v-model.trim="email" placeholder="Email address">
        <div class="tooltip right" v-show="needCheck && emailError">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner">{{emailError}}</div>
        </div>
      </div>
      <div class="form-group">
        <textarea v-model.trim="msgText" placeholder="Message"></textarea>
        <div class="tooltip right" v-show="needCheck && $vuerify.$errors['msgText']">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-inner">{{$vuerify.$errors['msgText']}}</div>
        </div>
      </div>
      <button @click.stop.prevent="sendMessage" v-show="!sending">
        <span v-show="!sended">{{sendMessageText}}</span>
        <i class="en en-checkmark" v-show="sended"></i>
      </button>
      <button class="spinner-button" v-show="sending">
        <div class="spinner">
          <div class="bounce1"></div>
          <div class="bounce2"></div>
          <div class="bounce3"></div>
        </div>
      </button>
    </form>
  </div>
</template>
<script>
  export default {
    name: 'ContactUs',
    props: ['place'],
    locales: {
      en: {
        telephone: '+86-21-60278098',
        companyAddress: '9F,Building C,Wison Plaza,No.699 Zhongke Rd,Pudong District,Shanghai 201210,China',
      },
      jp: {
        telephone: '03-5847-7996',
        companyAddress: '東京都中央区日本橋兜町5-1  兜町第1平和ビル3階',
      },
    },
    data() {
      return {
        countdown: 0,
        sended: false, // 成功发送标志，true表示发送成功
        sending: false, // 发送中标志，true表示发送中
        needCheck: true,
        showTopBG: false,
        topBGColor: 'transparent',
        topBGImageURL: '',
        topBGTopOffest: '-48px',
        marginTop: '0',
        bgColor: 'transparent',
        height: '1024px',
        bgImageURL: '',
        bgImageMap: {
          index: '/assets/images/contactUs/shanghai-bg.png',
          indexJP: '/assets/images/contactUs/japan-bg.png',
          product: '/assets/images/contactUs/product-bg.png',
          about: '/assets/images/contactUs/about-bg.png',
        },
        topBGImageMap: {
          product: 'assets/images/contactUs/balloon-bg.png',
          start: 'assets/images/contactUs/start-bg.png',
        },
        email: '',
        fullName: '',
        msgText: '',
      };
    },
    vuerify: {
      fullName: {
        test: /.+/,
        message: 'Please input fullname',
      },
      email: [{
        test: /.+/,
        message: 'Please input email',
      }, {
        test: /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,4}$/,
        message: 'Please input a correct email',
      }],
      msgText: {
        test: /.+/,
        message: 'Please input message',
      }
    },
    computed: {
      emailError() {
        if (this.$vuerify.$errors['email']) {
          return this.$vuerify.$errors['email'][0];
        }
        return '';
      },

      sendMessageText() {
        if (this.countdown === 0) {
          return 'SEND MESSAGE';
        } else if (this.countdown < 0) {
          return 'UNAVAILABLE';
        }

        return `SEND MESSAGE after ${this.countdown}s`;
      }
    },
    created() {
      const height = document.documentElement.clientHeight;
      this.height = `${height}px`;
      let bgURL = this.bgImageMap.product;
      if (this.bgImageMap[this.place]) {
        bgURL = this.bgImageMap[this.place];
      }

      switch (this.place) {
        case 'index':
          this.bgColor = '#F1F7FC';
          this.$translate.$on('language:init', language => {
            if (language === 'jp') {
              // 日语展示日本公司地图
              this.bgImageURL = `url('${this.bgImageMap.indexJP}')`;
            }
          });

          // 监听切换语言事件
          this.$translate.$on('language:changed', language => {
            if (language === 'jp') {
              // 日语展示日本公司地图
              this.bgImageURL = `url('${this.bgImageMap.indexJP}')`;
            } else {
              this.bgImageURL = `url('${this.bgImageMap.index}')`;
            }
          });
          break;
        case 'product':
          this.marginTop = '80px';
          this.height = 'auto';
          this.showTopBG = true;
          this.topBGColor = '#F1F7FC';
          this.topBGImageURL = this.topBGImageMap.product;
          this.topBGTopOffest = '-80px';
          this.bgColor = 'transparent';
          break;
        case 'about':
          this.height = 'auto';
          this.bgColor = 'transparent';
          break;
        case 'techspec':
          this.height = 'auto';
          this.bgColor = '#EFF7FD';
          break;
        case 'start':
          this.showTopBG = true;
          this.topBGImageURL = this.topBGImageMap.start;
          this.height = 'auto';
          this.bgColor = 'transparent';
          break;
        default:
          break;
      }
      this.bgImageURL = `url('${bgURL}')`;
    },
    methods: {
      sendMessage() {
        // 如果倒计时没有结束，不让发送
        if (this.countdown > 0) {
          return;
        }

        this.needCheck = true;
        if (!this.$vuerify.check()) {
          return;
        }

        // 如果倒计时小于等于0，重置为60秒，然后继续倒计时
        this.countdown = 60;

        this.sending = true;
        const message = {
          fullName: this.fullName,
          email: this.email,
          message: this.msgText,
        };

        const server = process.env.NODE_ENV === 'production' ? 'https://portal.everonet.com' :
          'http://localhost:6900';
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === xhr.DONE) {
            // 发送结束，sending置为false
            this.sending = false;
            switch (xhr.status) {
              case 200:
                // 发送成功，sended置为true
                this.sended = true;
                this.needCheck = false;
                this.fullName = '';
                this.email = '';
                this.msgText = '';
                this.$vuerify.clear();

                // 8秒后重新显示 send message 语句
                setTimeout(function () {
                  this.sended = false;
                }.bind(this), 8000);

                this.interval = setInterval(function () {
                  this.countdown = this.countdown - 1;
                  if (this.countdown === 0) {
                    clearInterval(this.interval);
                  }
                }.bind(this), 1000);
                break;
              case 400:
                alert('Please check the form data is OK?');
                this.countdown = 0;
                break;
              default:
                this.countdown = -1;
            }
          }
        }.bind(this);

        xhr.open('POST', `${server}/public/everonet/message`);
        xhr.send(JSON.stringify(message));
      }
    }
  };
</script>
<style>
  #contactUs {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #FFF;
    position: relative;
    padding-top: 136px;
    padding-bottom: 40px;
  }
  
  .top-bg-wrapper {
    position: absolute;
    top: -80px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: -2;
  }
  
  .bg-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    background-image: url('/assets/images/contactUs/product-bg.png');
    background-size: 100% 100%;
    position: 0 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }
  
  .bg-wrapper>img {
    width: 100%;
  }
  
  #contactUs>.en-email {
    font-size: 36px;
    margin-bottom: 20px;
    line-height: 1;
  }
  
  #contactUs>.en-tel {
    margin-top: 0;
    margin-bottom: 20px;
    font-family: PingFangSC-Semibold, sans-serif;
  }
  
  #contactUs>.en-address {
    margin-top: 0;
    margin-bottom: 38px;
    font-size: 16px;
    font-family: PingFangSC-Light, sans-serif;
  }
  
  .en-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .en-form>.form-group {
    width: 514px;
    margin-bottom: 10px;
    position: relative;
  }
  
  .en-form>.form-group:last-of-type {
    margin-bottom: 20px;
  }
  
  .form-group>.tooltip {
    position: absolute;
    left: 100%;
    top: 0;
    width: 200px;
    height: 30px;
    line-height: 30px;
  }
  
  .tooltip {
    z-index: 1070;
    display: block;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    filter: alpha(opacity=0);
    line-break: auto;
  }
  
  .japanese .tooltip {
    font-family: inherit;
  }
  
  .tooltip.right {
    padding: 0 5px;
    margin-left: 3px;
  }
  
  .tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  
  .tooltip.right .tooltip-arrow {
    top: 50%;
    left: 0;
    margin-top: -5px;
    border-width: 5px 5px 5px 0;
    border-right-color: rgba(0, 0, 0, 0.7);
  }
  
  .tooltip-inner {
    max-width: 200px;
    padding: 0px 8px;
    color: #fff;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 4px;
  }
  
  .form-group>input,
  .form-group>textarea {
    width: 100%;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
  }
  
  .form-group>input {
    height: 30px;
  }
  
  .form-group>textarea {
    height: 200px;
  }
  
  .form-group>input::-webkit-input-placeholder,
  .form-group>textarea::-webkit-input-placeholder {
    text-align: center;
  }
  
  .form-group>input:-moz-placeholder,
  .form-group>textarea:-moz-placeholder {
    /* Firefox 18- */
    text-align: center;
  }
  
  .form-group>input::-moz-placeholder,
  .form-group>textarea::-moz-placeholder {
    /* Firefox 19+ */
    text-align: center;
  }
  
  .form-group>input:-ms-input-placeholder,
  .form-group>textarea:-ms-input-placeholder {
    text-align: center;
  }
  
  .form-group>input:focus,
  .form-group>textarea:focus {
    outline: 0;
  }
  
  .en-form>button {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    padding: 10px 16px;
    font-size: 14px;
    line-height: 1.33;
    border-radius: 6px;
    color: #fff;
    background-color: #03cf11;
    border-color: #4cae4c;
    width: 204px;
    height: 52px;
    box-shadow: 0px 5px 10px rgba(100, 100, 100, 0.6);
    font-family: PingFangSC-Semibold, sans-serif;
  }
  
  .en-form>button:focus {
    outline: 0;
  }
  
  .en-form>button>i.en {
    font-size: 20px;
  }
  
  button.spinner-button {
    display: flex;
    justify-content: center;
  }
  
  .spinner {
    width: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner>div {
    width: 18px;
    height: 18px;
    background-color: #FFF;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }
  
  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  
  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  
  @-webkit-keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0)
    }
    40% {
      -webkit-transform: scale(1.0)
    }
  }
  
  @keyframes sk-bouncedelay {
    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }
    40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }
</style>


// WEBPACK FOOTER //
// ContactUs.vue?59d66762